import { LitElement, html, css } from 'lit';

class ConfirmDialog extends LitElement {
  static properties = {
    _open: { state: true },
    _message: { state: true },
  };

  static styles = css`
    :host { display: none; }
    :host([open]) { display: block; position: fixed; inset: 0; background: rgba(0,0,0,0.5); z-index: 95; }
    .container { display: flex; align-items: center; justify-content: center; height: 100%; padding: 1rem; }
    .dialog { background: white; border-radius: 0.75rem; box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25); max-width: 28rem; width: 100%; padding: 1.5rem; }
    p { margin: 0 0 1.5rem; color: #374151; line-height: 1.5; }
    .actions { display: flex; gap: 0.75rem; justify-content: flex-end; }
    button { padding: 0.5rem 1rem; border-radius: 0.5rem; font-weight: 600; cursor: pointer; border: none; font-size: 0.875rem; }
    .cancel { background: #F3F4F6; color: #374151; }
    .cancel:hover { background: #E5E7EB; }
    .confirm { background: #DC2626; color: white; }
    .confirm:hover { background: #B91C1C; }
  `;

  constructor() {
    super();
    this._open = false;
    this._message = '';
    this._resolve = null;
  }

  connectedCallback() {
    super.connectedCallback();
    this._onConfirm = (e) => this._show(e.detail.message, e.detail.resolve);
    window.addEventListener('confirm-show', this._onConfirm);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('confirm-show', this._onConfirm);
  }

  _show(message, resolve) {
    this._message = message;
    this._resolve = resolve;
    this._open = true;
    this.setAttribute('open', '');
  }

  _respond(result) {
    this._open = false;
    this.removeAttribute('open');
    if (this._resolve) this._resolve(result);
    this._resolve = null;
  }

  render() {
    if (!this._open) return html``;
    return html`
      <div class="container">
        <div class="dialog">
          <p>${this._message}</p>
          <div class="actions">
            <button class="cancel" @click=${() => this._respond(false)}>Cancel</button>
            <button class="confirm" @click=${() => this._respond(true)}>Confirm</button>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('confirm-dialog', ConfirmDialog);

export function confirmAction(message) {
  return new Promise((resolve) => {
    window.dispatchEvent(new CustomEvent('confirm-show', {
      detail: { message, resolve },
    }));
  });
}
